import { FC, useCallback } from 'react';
import { useMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import SyncIcon from '@mui/icons-material/Sync';
import LoadingButton from '@mui/lab/LoadingButton';
import ToolCard from 'components/ToolCard';

import { useErrorHandler } from 'lib';
import { TripPricesCardMutation } from '__generated__/TripPricesCardMutation.graphql';

const TripPricesCard: FC = () => {
  const errorHandler = useErrorHandler();

  const [recalculate, calculating] =
    useMutation<TripPricesCardMutation>(graphql`
      mutation TripPricesCardMutation {
        recalculateTripPrices
      }
    `);

  const handleRecalculate = useCallback(() => {
    recalculate({
      variables: {},

      ...errorHandler({
        successMessage: 'Aktyvių kelionių kainos perskaičiuotos',
      }),

      updater: store => {
        const root = store.getRoot();

        root.invalidateRecord();
      },
    });
  }, [errorHandler, recalculate]);

  return (
    <ToolCard
      icon={<SyncIcon fontSize="large" />}
      title="Kelionių kainos"
      description="Perskaičiuoti aktyvių kelionių kainas"
      action={
        <LoadingButton
          startIcon={<SyncIcon />}
          loading={calculating}
          size="small"
          onClick={handleRecalculate}>
          Perskaičiuoti
        </LoadingButton>
      }
    />
  );
};

export default TripPricesCard;
